<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="用户权限管理" CMname="功能管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="功能名称">
                        <el-input v-model="searchform.functionName" placeholder="关键字"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick()" v-if="isHadFun('Add')">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick()" v-if="isHadFun('Update')">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick()" v-if="isHadFun('Delete')">删除</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" border stripe highlight-current-row style="width: 100%" ref="Funtable" @cell-click="cellclick" @selection-change="selectionchange" v-loading="loading">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column prop="functionName" label="功能名称" width="180">
                    </el-table-column>
                    <el-table-column prop="functionDesc" label="功能描述">
                    </el-table-column>
                    <el-table-column prop="functionCode" label="功能代码" width="180">
                    </el-table-column>
                    <el-table-column prop="functionType" label="功能类型" width="180">
                        <template slot-scope="scope">
                            <span v-if="scope.row.functionType=='common'" disable-transitions>通用</span>
                            <span v-if="scope.row.functionType=='private'" type="danger" disable-transitions>私有</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="moduleName" label="专属模块名称" width="180">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="180">
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="180">
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="180">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status?'primary':'danger'" disable-transitions>{{scope.row.status?'启用':'禁用'}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small" v-if="isHadFun('Update')">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="isHadFun('Delete')">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'function',
    data() {
        return {
            searchform: {
                pageNum: 1,
                pageSize: 10,
                functionName: ""
            },
            tableData: [],
            moduleData: [],
            total: 0,
            loading: true,
            selectionRows: []
        }
    },
    methods: {
        onSubmit() {
            this.initData();
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        Rowview(val) {
            const Functionid = val.functionId;
            this.$route.meta.row = val;
            this.$router.push({
                path: '/system/function/view/' + Functionid
            });
        },
        RowEdit(val) {
            const Functionid = val.functionId;
            this.$route.meta.row = val;
            this.$router.push({
                path: '/system/function/edit/' + Functionid
            });
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.functionName + "' ？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.system.function+"/" + val.functionId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        Addclick() {
            this.$router.push({
                path: '/system/function/add/',
            });
        },
        editclick() {
            if (this.selectionRows.length == 0) {
                this.$message.warning("请先选择一行记录");
                return;
            }
            if (this.selectionRows.length > 1) {
                this.$message.warning("只能操作一行记录");
                return;
            }
            this.$route.meta.row = this.selectionRows[0];
            this.$router.push({ path: '/system/function/edit/' + this.selectionRows[0].functionId });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios({
                            method: "delete",
                            url: this.$api.system.function + "/" + myrow.functionId
                        });
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        cellclick(row, column, cell, event) {
            this.$refs.Funtable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(Vuethis.$api.system.functionList, {
                    params: Vuethis.searchform
                })
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        next();
    },
    created() {
        this.$common.getFunListByMCode(this,"SystemFunction",()=>{
				this.initData();
			});
    }
}
</script>